import React, { Component } from 'react';
import Layout from '../header_footer/Layout';

export default class Aldeia extends Component {
  render() {
    return (
      <Layout>
        <div>
          <h3>Ola da pagina da aldeia</h3>
        </div>
      </Layout>
      
    )
  }
}
